"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderWithInput = void 0;
const react_1 = __importStar(require("react"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_slider_1 = __importDefault(require("@motorata/base-ui.components.atoms.slider"));
const base_ui_components_atoms_input_1 = __importDefault(require("@motorata/base-ui.components.atoms.input"));
function Index(_a) {
    var { label, value, name, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => { }, min, max, step, labelIcon, valueLabel, marginTop = "S", marginBottom = "S" } = _a, rest = __rest(_a, ["label", "value", "name", "onChange", "min", "max", "step", "labelIcon", "valueLabel", "marginTop", "marginBottom"]);
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, Object.assign({ width: "100%", marginTop: marginTop, marginBottom: marginBottom }, rest),
        react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { width: "100%", marginBottom: "XS", justifyContent: "space-between" },
            label && (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary", icon: labelIcon, margin: "0" }, label)),
            valueLabel && (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary", color: "primary", margin: "0" }, valueLabel))),
        react_1.default.createElement(base_ui_components_atoms_slider_1.default, { value: value, name: name, min: min, max: max, step: step, onChange: onChange })));
}
exports.default = Index;
function SliderWithInput(_a) {
    var { label, value, name, startAdornment, endAdornment, inputWidth = "fit-content", 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => { }, min = 0, max = 100, decimalScale = 0, step, labelIcon, marginTop = "S", marginBottom = "S", disabledInput = false } = _a, rest = __rest(_a, ["label", "value", "name", "startAdornment", "endAdornment", "inputWidth", "onChange", "min", "max", "decimalScale", "step", "labelIcon", "marginTop", "marginBottom", "disabledInput"]);
    const timeoutId = (0, react_1.useRef)(null);
    const [tmp, setTmp] = (0, react_1.useState)(value);
    const handleOnChange = (value) => {
        onChange({
            name: name,
            value: value,
        });
    };
    const handleOnInputChange = ({ value }) => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        if (value <= max && value >= min) {
            // @ts-ignore
            timeoutId.current = setTimeout(() => {
                setTmp(value);
                handleOnChange(value);
            }, 1000);
        }
        else if (value > max) {
            // @ts-ignore
            timeoutId.current = setTimeout(() => {
                setTmp(max);
                handleOnChange(max);
            }, 1000);
        }
        else if (value < min) {
            // @ts-ignore
            timeoutId.current = setTimeout(() => {
                setTmp(min);
                handleOnChange(min);
            }, 1000);
        }
    };
    (0, react_1.useEffect)(() => {
        setTmp(value);
    }, [value]);
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, Object.assign({ width: "100%", marginTop: marginTop, marginBottom: marginBottom }, rest),
        react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { width: "100%", marginBottom: "XS", alignItems: "flex-end", justifyContent: "space-between" },
            label && (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary", icon: labelIcon, margin: "0", marginRight: "S" }, label)),
            react_1.default.createElement(base_ui_components_atoms_input_1.default, { elementType: "numeric", name: name, width: inputWidth, textAlign: "right", startAdornment: startAdornment, endAdornment: endAdornment, decimalScale: decimalScale, value: tmp, onChange: handleOnInputChange, disabled: disabledInput })),
        react_1.default.createElement(base_ui_components_atoms_slider_1.default, { value: value, name: name, min: min, max: max, step: step, onChange: onChange })));
}
exports.SliderWithInput = SliderWithInput;
//# sourceMappingURL=index.js.map